import { Card } from '@/shared/components/ui/card';
import { cn } from '@/shared/lib/utils';
import React from 'react';

interface DataCardProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * 테이블·목록 데이터 영역 래퍼.
 * RDS Card(Horizontal Small) 셸 — radius 20 + 이중 그림자.
 */
export const DataCard: React.FC<DataCardProps> = ({ children, className }) => (
  <Card size="md" className={cn(className)}>
    {children}
  </Card>
);
